"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EarnMode = exports.DeviceType = exports.TicketEntryMethod = exports.AttributeType = exports.PrizeType = exports.TicketStatus = exports.TicketCheckingScanAction = exports.RESET_ERROR_VALIDATIONS = exports.CLEAR_VALIDATIONS = exports.ENTER_TICKET_BAR_CODE = exports.FETCH_DRAWS_BY_IDS = exports.CLEAR_PRIZES = exports.UPDATE_ATTR = exports.ENTER_TICKET = exports.CLEAR_ERROR = exports.RESET = void 0;
var PrizeType;
(function (PrizeType) {
    PrizeType["COUPON"] = "COUPON";
    PrizeType["LOYALTY_POINTS"] = "LOYALTY_POINTS";
    PrizeType["ENTRY"] = "ENTRY";
    PrizeType["TOKENS"] = "TOKENS";
})(PrizeType || (PrizeType = {}));
exports.PrizeType = PrizeType;
var AttributeType;
(function (AttributeType) {
    AttributeType["GROUP"] = "GROUP";
    AttributeType["PREASSIGNED_ENTRY"] = "PREASSIGNED_ENTRY";
    AttributeType["PREASSIGNED_LOYALTY_POINTS"] = "PREASSIGNED_LOYALTY_POINTS";
})(AttributeType || (AttributeType = {}));
exports.AttributeType = AttributeType;
var TicketEntryMethod;
(function (TicketEntryMethod) {
    TicketEntryMethod["SCAN"] = "SCAN";
    TicketEntryMethod["MANUAL"] = "MANUAL";
    TicketEntryMethod["ONLINE"] = "ONLINE";
})(TicketEntryMethod || (TicketEntryMethod = {}));
exports.TicketEntryMethod = TicketEntryMethod;
var DeviceType;
(function (DeviceType) {
    DeviceType["IOS"] = "IOS";
    DeviceType["ANDROID"] = "ANDROID";
    DeviceType["WEB"] = "WEB";
})(DeviceType || (DeviceType = {}));
exports.DeviceType = DeviceType;
var EarnMode;
(function (EarnMode) {
    EarnMode["WINNING_TICKETS"] = "WINNING_TICKETS";
    EarnMode["NON_WINNING_TICKETS"] = "NON_WINNING_TICKETS";
    EarnMode["WINNING_AND_NON_WINNING"] = "WINNING_AND_NON_WINNING";
    EarnMode["ALL"] = "ALL";
})(EarnMode || (EarnMode = {}));
exports.EarnMode = EarnMode;
var TicketStatus;
(function (TicketStatus) {
    TicketStatus["PENDING"] = "PENDING";
    TicketStatus["CANCELLED"] = "CANCELLED";
    TicketStatus["VERIFIED"] = "VERIFIED";
    TicketStatus["REWARDED"] = "REWARDED";
    TicketStatus["INVALID_REWARDED"] = "INVALID_REWARDED";
    TicketStatus["INVALID"] = "INVALID";
})(TicketStatus || (TicketStatus = {}));
exports.TicketStatus = TicketStatus;
var TicketCheckingScanAction;
(function (TicketCheckingScanAction) {
    TicketCheckingScanAction["CHECK_INSTANT_TICKET_BAR_CODE"] = "ticket/CHECK_INSTANT_TICKET_BAR_CODE";
    TicketCheckingScanAction["CHECK_DRAW_TICKET_BAR_CODE"] = "ticket/CHECK_DRAW_TICKET_BAR_CODE";
    TicketCheckingScanAction["CHECK_FAST_PLAY_TICKET_BAR_CODE"] = "ticket/CHECK_FAST_PLAY_TICKET_BAR_CODE";
    TicketCheckingScanAction["CHECK_QUICK_CARD_TICKET_BAR_CODE"] = "ticket/CHECK_QUICK_CARD_TICKET_BAR_CODE";
})(TicketCheckingScanAction || (TicketCheckingScanAction = {}));
exports.TicketCheckingScanAction = TicketCheckingScanAction;
var RESET = 'ticket/RESET';
exports.RESET = RESET;
var ENTER_TICKET = 'ticket/ENTER_TICKET';
exports.ENTER_TICKET = ENTER_TICKET;
var ENTER_TICKET_BAR_CODE = 'ticket/ENTER_TICKET_BAR_CODE';
exports.ENTER_TICKET_BAR_CODE = ENTER_TICKET_BAR_CODE;
var CLEAR_ERROR = 'ticket/CLEAR_ERROR';
exports.CLEAR_ERROR = CLEAR_ERROR;
var UPDATE_ATTR = 'ticket/UPDATE_ATTR';
exports.UPDATE_ATTR = UPDATE_ATTR;
var CLEAR_PRIZES = 'ticket/CLEAR_PRIZES';
exports.CLEAR_PRIZES = CLEAR_PRIZES;
var FETCH_DRAWS_BY_IDS = 'ticket/FETCH_DRAWS_BY_IDS';
exports.FETCH_DRAWS_BY_IDS = FETCH_DRAWS_BY_IDS;
var CLEAR_VALIDATIONS = 'ticket/CLEAR_VALIDATIONS';
exports.CLEAR_VALIDATIONS = CLEAR_VALIDATIONS;
var RESET_ERROR_VALIDATIONS = 'ticket/RESET_ERROR_VALIDATIONS';
exports.RESET_ERROR_VALIDATIONS = RESET_ERROR_VALIDATIONS;
//# sourceMappingURL=types.js.map